//todo sistemare try catch pagamento finanziamento e renting
function ChangePagamento(data) {
    try {
        $("#mbway").fadeOut("slow", function () {
            $(this).addClass("hidden");
        });
        $('#finanziamento').addClass('hidden');
        $('#renting').addClass('hidden');
        $('#ifis').addClass('hidden');
        $('#rate-value').html('');

        try {
            $('#rblFinanziamento').dxRadioGroup('instance').reset();
        }
        catch (error) {

        }

        try {
            $('#rblRenting').dxRadioGroup('instance').reset();
        }
        catch (error) {

        }

        try {
            $('#rblIfis').dxRadioGroup('instance').reset();
        }
        catch (error) {

        }

        $('#rfinanziamento').val('');
        $('#rrenting').val('');
        $('#rifis').val('');
        $('#rdescrizione').val('');

        var elementId = '#' + data.element[0].id;

        var elementInstance = $(elementId).dxRadioGroup('instance');
        var elementDataSource = elementInstance.option('dataSource');

        var tipopagamento = elementDataSource.store._array.filter(function (item) {
            return item.IDTipologiaPagamento == data.value;
        });

        var idPag = null;

        if (tipopagamento != null && tipopagamento != undefined && tipopagamento.length == 1) {
            idPag = tipopagamento[0].TipoPagamento;
        }
        
        $('#paytypename').val(idPag);

        $('#paytype').val(idPag == null ? null : data.value);

        mainController.RefreshTotali(0, '', false, '', data.value);

        switch (data.value) {
            case 10:
                $('#finanziamento').removeClass('hidden');
                break;
            case 23:
                $('#renting').removeClass('hidden');
                break;
            case 62: //MBWAY
                $("#mbway").fadeIn("slow", function () {
                    $(this).removeClass("hidden");
                });
                break;
            case 63://Ifis
                $('#ifis').removeClass('hidden');
                break;
        }

        try {
            if (typeof dataLayer !== 'undefined') {
                var p = {};
                p.ga4event = 'add_payment_info';

                mainController.CallServiceAsync('/Checkout/GetCartDetail', p)
                    .then(function (r) {
                        if (r != null && r != undefined) {
                            var products = JSON.parse(r.JsonObject);
                            ga4.e_pushEventMulti(products, 'add_payment_info', r.Valuta, idPag, r.TotaleOrdine, r.CodiceBuonoSconto);
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            }
        }
        catch (error) {
            console.log(error);
        }
    }
    catch (error) {
        console.log(error);
    }
}

function save_tel() {
    $('#cellulare').val($('#mbwaytel').val());
}

function renting_valueChanged(e) {
    var elementId = '#rblRenting';
    var elementInstance = $(elementId).dxRadioGroup('instance');
    var elementDataSource = elementInstance.option('dataSource');
    var t = elementDataSource.store._array.filter(function (item) {
        return item.id == e.value;
    });

    $('#rrenting').val(e.value);
    $('#rdescrizione').val(t[0].text);

    waitingBS.Show();
    var params = {
        valore: $('#timponibilenetto').val(),
        nrate: e.value
    };

    mainController.CallServiceAsync('/Checkout/CalcolaRataRenting', params)
        .then(function (r) {
            waitingBS.Hide();
            if (r.esito == Costanti.ESITO_OK) {
                $('#rate-value').html('L\'importo della rata mensile &egrave; pari a: <strong>' + r.responseText + ' €</strong> (iva, spese accessorie e spese di trasporto escluse).');
            }
            else {
                mainController.NotifyMessage(r.responseText, r.NotifyColor);
                elementInstance.option('value', null);
            }
        })
        .catch(function (error) {
            console.log(error);
            waitingBS.Hide();
            mainController.NotifyMessage(r.responseText, r.NotifyColor);
        });


    waitingBS.Hide();
}

function ifis_valueChanged(e) {
    var selectedKey = e.value;
    var items = e.component.getDataSource().items();
    var valore = items.find((x) => x.Key == selectedKey)

    $("#tipoFinanziamento").val(valore.Key);
    $("#rifis").val(valore.Key);
    $("#rdescrizione").val(valore.Value);
}

function finanziamento_valueChanged(e) {
    var elementId = '#rblFinanziamento';
    var elementInstance = $(elementId).dxRadioGroup('instance');
    var elementDataSource = elementInstance.option('dataSource');
    var t = elementDataSource.store._array.filter(function (item) {
        return item.id == e.value;
    });
    $("#tipoFinanziamento").val(t[0].id);
    $("#rfinanziamento").val(e.value);
    $("#rdescrizione").val(t[0].text);
}

function toggleship(c, t) {
    $("." + c).toggle(700);
    if (t != undefined) {
        scrollTo($(t)[0].offsetLeft, $(t)[0].offsetTop - document.getElementsByTagName('header')[0].offsetTop)
    }
}

function select_address(id) {
    waitingBS.Show();
    $("#hidsped").val(id);
    $("#freloadspedizione").submit();
}

function PFIContentReady(e) {
    e.component.content().parent().attr('id', 'overlayPopup');
}



/**
 * Funzione chiamata nella pagina CheckoutSpedizione.cshtml che passa il json del modello della pagina
 * @param {string} json
 */
function CheckoutSpedizione_DocumentReady(json) {


    var model = JSON.parse(json); //parsifico il json in un oggetto

    if (typeof (model) === 'string') { // se il modello è ancora una string, riprovo a parsificarlo
        model = JSON.parse(model);
    }

    //Indirizzo di spedizione
    $('#shippingType').val('ConsegnaStandard');
    $('#pnuovoindirizzo').hide();
    $('#plistaindirizzi').hide();
    $('#finsertorupdateindirizzospedizione0').submit(function (e) {
        try {
            waitingBS.Show();
            var formData = new FormData(this);
            var r = mainController.CallServiceFormDataAsync($('#finsertorupdateindirizzospedizione0').attr('action'), formData)
                .then(function (r) {
                    if (r.esito == Costanti.ESITO_OK) {
                        $("#hidsped").val(r.responseText);
                        $("#freloadspedizione").submit();
                    }
                    else {
                        waitingBS.Hide();
                        mainController.NotifyMessage(r.responseText, r.NotifyColor);
                    }
                })
                .catch(function (error) {
                    console.log(error);
                    waitingBS.Hide();
                    mainController.NotifyMessage(r.responseText, r.NotifyColor);
                });
        }
        catch (error) {
            console.log(error);
            waitingBS.Hide();
        }

        e.preventDefault();
    });



    //Note e tipo di pagamento
    try {
        if (model != null && model.NoteOrdine != null && model.NoteOrdine.length > 0) {
            $('#taNoteConsegna').val(model.NoteOrdine);
        }

        if (model != null && model.IdTipoPagamento > 0) {
            var rgPagamenti = $('#TipologiePagamento').dxRadioGroup('instance');
            rgPagamenti.option('value', model.IdTipoPagamento);

            if (model.RateRenting != null && model.RateRenting?.trim().length > 0) {
                $('#rblRenting').dxRadioGroup('instance').option('value', model.RateRenting);
            }

            if (model.RateIfis != null && model.RateIfis?.trim().length > 0) {
                $('#rblIfis').dxRadioGroup('instance').option('value', model.RateIfis);
            }

            if (model.TipoFinanziamento != null && model.TipoFinanziamento?.trim().length > 0) {
                $('#rblFinanziamento').dxRadioGroup('instance').option('value', model.TipoFinanziamento);
            }

            setTimeout(function () {
                var tipoPagamento = rgPagamenti.option('value');
                if (tipoPagamento == 23) {
                    $("#renting").show("fast");
                }
                else if (tipoPagamento == 63) {
                    $("#ifis").show("fast");
                }
                else if (tipoPagamento == 10) {
                    $("#finanziamento").show("fast");
                }
            }, 250);
        }
    }
    catch (error) {
        console.log(error);
    }



    //Dati aggiuntivi consegna
    var dettagli = model.DettagliSpedizione;

    if (dettagli == null) {
        dettagli = {
            ConsegnaProgrammata: null,
            IsConsegnaPianoApp: null,
            IsConsegnaSabato: null,
            IsConsegnaSabatoApp: null,
            IsCosegnaSera: null,
            IsConsegnaPiano: null,
            TipoSpedizione: 0,
            CostoConsegnaProgrammata: null,
            CostoConsegnaPiano: null,
            CostoConsegnaPianoApp: null,
            CostoConsegnaSabato: null,
            CostoCosegnaSera: null,
            CostoConsegnaSabatoApp: null,
            CostoServiziAggiuntiviEccessivi: false
        };
    }

    try {
        var ListaDiRadioGroup = $('div [id^="rg"]');

        if (ListaDiRadioGroup.length == 1) {
            var value = $(ListaDiRadioGroup[0]).dxRadioGroup('getDataSource')._items[0].Key;
            $(ListaDiRadioGroup[0]).dxRadioGroup('instance').option('value', value);
            if (value.toLowerCase().includes('express')) {
                $('#tipospedizione').val(Costanti.TIPO_SPEDIZIONE_VELOCE);
            }
            else {
                $('#tipospedizione').val(Costanti.TIPO_SPEDIZIONE_LENTA);
            }
        }
        else if (ListaDiRadioGroup.length > 1) {
            var spedizioni = [
                {
                    Key: 'ConsegnaProgrammata',
                    Value: (/true/).test(dettagli.ConsegnaProgrammata?.toString()?.toLowerCase())
                },
                {
                    Key: 'IsConsegnaPiano',
                    Value: (/true/).test(dettagli.IsConsegnaPiano?.toString()?.toLowerCase())
                },
                {
                    Key: 'IsConsegnaPianoApp',
                    Value: (/true/).test(dettagli.IsConsegnaPianoApp?.toString()?.toLowerCase())
                },
                {
                    Key: 'IsConsegnaSabatoApp',
                    Value: (/true/).test(dettagli.IsConsegnaSabatoApp?.toString()?.toLowerCase())
                },
                {
                    Key: 'IsConsegnaSabato',
                    Value: (/true/).test(dettagli.IsConsegnaSabato?.toString()?.toLowerCase())
                },
                {
                    Key: 'IsCosegnaSera',
                    Value: (/true/).test(dettagli.IsCosegnaSera?.toString()?.toLowerCase())
                }
            ];

            $.each(ListaDiRadioGroup, function (index, value) {
                var IdRadioGroup = '#' + value.id;
                var rbgElem = $(IdRadioGroup).dxRadioGroup('instance');

                var spedizione = spedizioni.find(item => {
                    return item.Value != false;
                });
                if (spedizione) {
                    var itemGiusto = $(IdRadioGroup).dxRadioGroup('getDataSource')._items.find(item => {
                        return item.Key == spedizione.Key;
                    });

                    if (itemGiusto) {
                        rbgElem.option('value', itemGiusto.Key);
                    }
                }
            });
            if (dettagli.TipoSpedizione == Costanti.TIPO_SPEDIZIONE_VELOCE) {
                $('#rgConsegnaExpress').dxRadioGroup('instance').option('value', 'ConsegnaExpress');
            }
        }
    }
    catch (error) {
        console.log(error);
    }


    //Modifica indirizzo di spedizione
    $('#finsertorupdateindirizzospedizione' + model.Spedizione.Id).submit(e => {
        try {
            waitingBS.Show();
            var formData = new FormData($('#finsertorupdateindirizzospedizione' + model.Spedizione.Id)[0]);
            mainController.CallServiceFormDataAsync($('#finsertorupdateindirizzospedizione' + model.Spedizione.Id).attr('action'), formData)
                .then(r => {
                    if (r) {
                        mainController.NotifyMessage(r.responseText, r.NotifyColor);
                        if (r.esito == Costanti.ESITO_OK) {
                            window.location.reload();
                        }
                        else {
                            waitingBS.Hide();
                        }
                    }
                    else {
                        waitingBS.Hide();
                        console.log('r is undefined');
                    }
                })
                .catch(function (error) {
                    console.log(error);
                    waitingBS.Hide();
                });
        }
        catch (error) {
            console.log(error);
            waitingBS.Hide();
        }

        e.preventDefault();
    });
}


function ElencoTipiPagamento_DocumentReady(json) {
    try {

        $('#rate-value').html('');


        var model = JSON.parse(json); //parsifico il json in un oggetto

        if (typeof (model) === 'string') { // se il modello è ancora una string, riprovo a parsificarlo
            model = JSON.parse(model);
        }

        //console.log(model);

        if (model.length == 1) {
            var rgPagamenti = $('#TipologiePagamento').dxRadioGroup('instance');

            var idPagamento = model[0].IDTipologiaPagamento;
            rgPagamenti.option('value', idPagamento);
            $('#paytype').val('' + idPagamento);
        }
        else {
            var idPag = $('#paytype').val();
            var Ids = model.map((x) => { return x.IDTipologiaPagamento });
            var rgPagamenti = $('#TipologiePagamento').dxRadioGroup('instance');
            if (idPag && idPag.length > 0 && Ids.includes(parseInt(idPag))) {

                rgPagamenti.option('value', parseInt(idPag));
            }
            else {
                rgPagamenti.option('value', null);
            }
        }

    } catch (ex) {
        console.log(ex);
    }
}

function CheckShipping(data, idSpedizione) {

    var ListaDiRadioGroup = $('div [id^="rg"]');
    var tipoSped = 0;

    $.each(ListaDiRadioGroup, function (index, value) {
        var IdRadioGroup = '#' + value.id;

        if (data.element[0].id != value.id && data.value != null) {

            $(IdRadioGroup).dxRadioGroup('instance').option('value', null);

            if (data.element[0].id.toLowerCase().includes('express')) {
                $('#tipospedizione').val(Costanti.TIPO_SPEDIZIONE_VELOCE);
                tipoSped = Costanti.TIPO_SPEDIZIONE_VELOCE;
            }
            else {
                $('#tipospedizione').val(Costanti.TIPO_SPEDIZIONE_LENTA);
                tipoSped = Costanti.TIPO_SPEDIZIONE_LENTA;
            }
        }
        else {
            $('#serviziAgg').val(data.value);
        }
    });

    $('#shippingType').val(data.value);

    if (!data.previousValue || (data.value && data.previousValue != data.value)) {
        setTimeout(function () {
            mainController.RefreshTotali(0, '', false, '');
        }, 50);
    }

    RefreshTipiPagamento(idSpedizione, tipoSped);
}

var refreshing = false;
function RefreshTipiPagamento(idSpedizione, tipoSped) {
    try {

        if (refreshing == false) {
            refreshing = true;

            var buonoSconto = $('#buonosconto').val();
            var giftcard = $('#giftcard').val();

            var dettagli = null;

            if (dettagli == null) {
                dettagli = {
                    ConsegnaProgrammata: null,
                    IsConsegnaPianoApp: null,
                    IsConsegnaSabato: null,
                    IsConsegnaSabatoApp: null,
                    IsCosegnaSera: null,
                    IsConsegnaPiano: null,
                    TipoSpedizione: tipoSped,
                    CostoConsegnaProgrammata: null,
                    CostoConsegnaPiano: null,
                    CostoConsegnaPianoApp: null,
                    CostoConsegnaSabato: null,
                    CostoCosegnaSera: null,
                    CostoConsegnaSabatoApp: null,
                    CostoServiziAggiuntiviEccessivi: false
                };
            }

            var ListaDiRadioGroup = $('div [id^="rg"]');

            $.each(ListaDiRadioGroup, function (index, value) {
                var IdRadioGroup = '#' + value.id;
                var rbgElem = $(IdRadioGroup).dxRadioGroup('instance');

                var servizio = rbgElem.option('value');

                if (servizio != null) {
                    dettagli.ConsegnaProgrammata = 'ConsegnaProgrammata' == servizio;
                    dettagli.IsConsegnaPianoApp = 'IsConsegnaPianoApp' == servizio;
                    dettagli.IsConsegnaSabato = 'IsConsegnaSabato' == servizio;
                    dettagli.IsConsegnaSabatoApp = 'IsConsegnaSabatoApp' == servizio;
                    dettagli.IsCosegnaSera = 'IsCosegnaSera' == servizio;
                    dettagli.IsConsegnaPiano = 'IsConsegnaPiano' == servizio;
                }
            });

            var params = {
                idSpedizione: idSpedizione,
                buonosconto: buonoSconto,
                giftcard: giftcard,
                dettagliSped: dettagli
            };

            //console.log(params);

            $.ajax({
                url: '/RefreshTipiPagamento',
                type: "POST",
                data: params,
                success: function (data) {
                    $("#Componente_ElencoTipiDiPagamento").html(data);
                    refreshing = false;
                },
                error: function (xhr, status, error) {
                    console.log(error);
                    console.log(status);
                    console.log(xhr);
                    refreshing = false;
                }
            });
        }
    } catch (ex) {
        console.log(ex);
    }
}